// Consent-Speicherung + Meta-Pixel-Loader mit revDSG/DSGVO-Gating
const KEY = "he_consent_v1";
const PIXEL_ID = "5464799657079036";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}

export function hasMarketingConsent() {
  return getConsent()?.marketing === true;
}

export function saveConsent(next) {
  const payload = {
    essential: true,
    marketing: !!next.marketing,
    ts: new Date().toISOString(),
    version: 1,
  };
  localStorage.setItem(KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent("he-consent-change", { detail: payload }));
  applyConsent(payload);
  return payload;
}

// --------- Meta Pixel loader ---------
let pixelLoaded = false;

function loadFbevents() {
  if (pixelLoaded) return;
  pixelLoaded = true;
  // Standard Meta Pixel snippet, aber ohne auto-init
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export function applyConsent(consent = getConsent()) {
  if (!consent) return;
  if (consent.marketing) {
    loadFbevents();
  }
  // Wenn abgelehnt: nichts laden. fbq bleibt undefined -> track-Calls sind no-op via safeFbq.
}

// Sicherer fbq-Wrapper — feuert nur, wenn Marketing-Consent aktiv
export function safeFbq(...args) {
  if (!hasMarketingConsent()) return false;
  if (typeof window === "undefined" || typeof window.fbq !== "function") return false;
  try { window.fbq(...args); return true; } catch { return false; }
}

// Beim Import auf Seiten anwenden (falls Consent bereits vorhanden)
if (typeof window !== "undefined") {
  const c = getConsent();
  if (c) applyConsent(c);
}
